var inputRange = {exports: {}};

export { inputRange as __module };
